<script setup>
import { computed, onMounted, ref } from "vue";
import { Bar } from "vue-chartjs";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  PointElement,
  LineElement,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  PointElement,
  LineElement,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement
);

const props = defineProps({
  data: { type: Array, required: true, default: () => [] },
  title: { type: String, default: "Total de estudantes por curso e graduação" },
});
const labels = computed(() =>
  props.data.map((item) => `${item.name} ( ${item.periods})`)
);
const values = computed(() => props.data.map((item) => Number(item.total)));
const chartData = computed(() => ({
  labels: labels.value,
  datasets: [
    {
      label: props.title,
      data: values.value,
      backgroundColor: "rgba(37, 99, 235, 0.3)",
    },
  ],
}));
</script>
<template>
  <Bar
    :data="chartData"
    :options="{ responsive: true, plugins: { legend: { position: 'top' } } }"
  />
</template>
 